import type { TranslationKey } from './types';

import { translations as translationsNL } from './nl';
import { translations as translationsFR } from './fr';

export type FlattenedObject = Record<string, string>;

const languages: Record<string, FlattenedObject> = {
  nl: flattenObject(translationsNL),
  fr: flattenObject(translationsFR),
};

export function flattenObject(value: any, keyParts = [], flattenedObject: any = {}): FlattenedObject {
  if (typeof value === 'object') {
    for (let key of Object.keys(value)) {
      let subValue = value[key];
      let newKeyParts: string[] = [...keyParts, key];
      if (typeof subValue !== 'object') {
        flattenedObject[newKeyParts.join('.')] = subValue;
      } else {
        // @ts-ignore
        flattenObject(subValue, newKeyParts, flattenedObject);
      }
    }
  }

  return flattenedObject;
}

const TEMPLATE_REGEX = /{{([0-9a-zA-Z_.]+)}}/g;

export function format(template: string, values: any = {}) {
  let flattenedValues = flattenObject(values);

  if (!template) {
    return '';
  }

  return template.replace(TEMPLATE_REGEX, (match, key, index) => {
    if (template[index - 1] === '{' && template[index + match.length] === '}') {
      return key;
    } else {
      let cleanedKey = key.trim();
      let result = flattenedValues.hasOwnProperty(cleanedKey) ? flattenedValues[cleanedKey] : null;
      if (result === null || result === undefined) {
        return '';
      } else {
        return result;
      }
    }
  });
}

export function t(language: string, key: TranslationKey, values: FlattenedObject = {}): string {
  let registry: FlattenedObject = languages[language.toLowerCase()] ?? languages.en;

  if (registry && typeof registry[key] === 'string') {
    return format(registry[key], values);
  } else {
    return key ?? '';
  }
}
